export const MATERIAL_GRADE_ID_PATTERN = /^[0-9]{4}$/;
export const MAX_GRADE_ID_LENGTH = 4;
export const UNASSIGNED_MATERIAL_GRADE_ID = '0';
